var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
import { getTrackBackground, Range } from 'react-range';
export const Slider = (_a) => {
    var { children, value = undefined, disabled, step = 1, min = 0, max = 100, onChange } = _a, rest = __rest(_a, ["children", "value", "disabled", "step", "min", "max", "onChange"]);
    const values = value ? [value] : [0];
    const renderTrack = ({ props, children }) => {
        return (React.createElement("div", { onMouseDown: props.onMouseDown, onTouchStart: props.onTouchStart, style: props.style, className: clsx('w-full flex items-center h-7', disabled && 'opacity-60 cursor-default pointer-events-none') },
            React.createElement("div", { ref: props.ref, className: clsx('w-full h-1 rounded-md', disabled && 'opacity-60 cursor-default pointer-events-none'), style: {
                    background: getTrackBackground({
                        values,
                        colors: [
                            'var(--bm-color-action-primary)',
                            'var(--bm-color-surface-subdued)',
                        ],
                        min,
                        max,
                    }),
                } }, children)));
    };
    const renderThumb = ({ props }) => (React.createElement("div", Object.assign({}, props, { className: clsx('w-5 h-5  transform translate-x-10 rounded-full', 'flex items-center justify-center', 'bg-action-primary', 'focus:outline-none focus-visible:ring focus-visible:ring-offset-2 focus-visible:ring-focused') })));
    return (React.createElement(Range, Object.assign({ min: min, max: max, step: step, values: values, onChange: values => {
            onChange(values === null || values === void 0 ? void 0 : values[0]);
        }, disabled: disabled, renderTrack: renderTrack, renderThumb: renderThumb }, rest)));
};
//# sourceMappingURL=Slider.js.map